import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iWorkFlowBackupListState {
    response: any;
    isLoading: boolean;
    message: string | null;
    backupList: any[];
}

const initialState: iWorkFlowBackupListState = {
    response: null,
    isLoading: false,
    message: "",
    backupList: [],
};

export const workFlowBackupListAPI = createAsyncThunk(
    "workFlowBackupListAPI",
    async (data: {
        group_name: string;
        library_name: string;
        round?: number; // optional로 변경

    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/backup-list/';
            
            // round가 있을 때만 포함
            const requestBody: any = {
                group_name: data.group_name,
                library_name: data.library_name,
            };
            
            if (data.round !== undefined) {
                requestBody.round = data.round;
            }
            
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, requestBody);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const workFlowBackupListSlice = createSlice({
    name: "workFlowBackupList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(workFlowBackupListAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(workFlowBackupListAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
                state.backupList = action.payload.backup_list;
            })
            .addCase(workFlowBackupListAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});


export default workFlowBackupListSlice.reducer;